import { styled } from '@mui/material';

export const StyledPhoneInputContainer = styled('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  '& .react-tel-input': {
    fontFamily: theme.typography.fontFamily,
  },
  '& .react-tel-input .form-control': {
    width: '100% !important',
    height: '56px',
    borderRadius: '8px !important',
    border: `1px solid ${theme.palette.grey[300]} !important`,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    paddingLeft: '52px !important',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    '&:hover, &:hover + .flag-dropdown': {
      borderColor: `${theme.palette.grey[400]} !important`,
    },
    '&:focus, &:focus + .flag-dropdown': {
      borderColor: `${theme.palette.primary[400]} !important`,
      boxShadow: 'none !important',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
      height: '48px',
    }
  },
  '& .react-tel-input .selected-flag': {
    backgroundColor: 'transparent !important',
    borderTopLeftRadius: '8px !important',
    borderBottomLeftRadius: '8px !important',
    width: '42px !important',
  },
  '& .react-tel-input .flag-dropdown': {
    borderRight: 'none !important',
    backgroundColor: 'transparent !important',
    borderTopLeftRadius: '8px !important',
    borderBottomLeftRadius: '8px !important',
    borderColor: `${theme.palette.grey[300]} !important`,
    '&:hover, &:focus': {
      backgroundColor: 'transparent !important',
    },
  },
  '& .react-tel-input .country-list': {
    margin: '4px 0',
    borderRadius: '8px',
    boxShadow: theme.shadows[3],
    border: 'none !important',
    '& .country:hover': {
      backgroundColor: `${theme.palette.background.default} !important`,
    },
    '& .country.highlight': {
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
  },
  '& .react-tel-input .search-box': {
    margin: '0 10px',
    width: 'calc(100% - 20px)',
    borderRadius: '8px',
    marginTop: '5px',
    padding: '10px',
    '&:focus': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  },
  '& .react-tel-input .search': {
    paddingLeft: '10px',
  },
  // Prevent restricting input
  '& input[type="tel"]': {
    boxSizing: 'border-box',
  },

}));
